module.exports = __webpack_public_path__ + "static/media/11musashino.9395e87b.png";